"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _styled = require("./styled.infoCard");

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var InformationCard = function InformationCard(props) {
  var newProps = _extends({}, _defaultProps2.default.props, props);
  var style = newProps.style,
      content = newProps.content,
      media = newProps.media,
      updateProps = newProps.updateProps,
      setData = newProps.setData,
      isEditMode = newProps.isEditMode;

  var styledRowProps = {
    columnPosition: getPropValue("text", "columnPosition", style.columnPosition, "style")
  };

  var imageProps = {
    src: getPropValue("text", "imageUrl", media.imageUrl, "media"),
    alt: getPropValue("text", "alt", media.alt, "media")
  };

  var titleProps = {
    titleColor: getPropValue("text", "titleColor", style.titleColor, "style"),
    titleFontSize: getPropValue("text", "titleFontSize", style.titleFontSize, "style"),
    titleText: getPropValue("text", "titleText", style.titleText, "style"),
    bottomSpace: getPropValue("text", "bottomSpace", style.bottomSpace, "style")
  };

  var infoProps = {
    topBorderColor: getPropValue("text", "topBorderColor", style.borderColor, "style"),
    bottomBorderColor: getPropValue("text", "bottomBorderColor", style.borderColor, "style"),
    contentSpace: getPropValue("text", "contentSpace", style.contentSpace, "style")
  };
  var paragraphProps = {
    textFontSize: getPropValue("text", "textFontSize", style.textFontSize, "style"),
    textColor: getPropValue("text", "textColor", style.textColor, "style")
  };
  var titleHeading = getPropValue("text", "heading", content.title, "content");
  var para1 = getPropValue("text", "paragraph1", content.paragraph1, "content");

  var para2 = getPropValue("text", "paragraph2", content.paragraph2, "content");

  return _react2.default.createElement(
    _reactBootstrap.Container,
    null,
    _react2.default.createElement(
      _styled.StyledRow,
      _extends({}, styledRowProps, { className: "row" }),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 6 },
        _react2.default.createElement(
          "div",
          { className: "draggable" },
          _react2.default.createElement(
            "figure",
            null,
            _react2.default.createElement(_styled.Image, imageProps)
          )
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 6, className: "pl-lg-5" },
        _react2.default.createElement(
          _styled.Title,
          titleProps,
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "title",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: titleHeading
          })
        ),
        _react2.default.createElement(
          _styled.Info,
          _extends({ className: "vendor-description" }, infoProps),
          _react2.default.createElement(
            _styled.Paragraph,
            paragraphProps,
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "paragraph1",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: para1
            })
          ),
          _react2.default.createElement(
            _styled.Paragraph,
            paragraphProps,
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "paragraph2",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: para2
            })
          )
        )
      )
    )
  );
};
exports.default = InformationCard;